import { InjectionModelRef } from '@/dto/scenario/ScenarioReference';
import { ScenarioMeta } from './ScenarioMeta';
import { ProjectTypeRef } from '@/dto/scenario/ProjectReference';

export class ProjectMeta {

  public static fromDto(dto: any): ProjectMeta {
    const constructorParams = { ...dto };
    if (dto.scenarios instanceof Array) {
      constructorParams.scenarios = dto.scenarios.map((o: any) => ScenarioMeta.fromDto(o));
    }
    return new ProjectMeta(constructorParams);
  }

  public uuid: string | undefined;
  public country3Ref: string | undefined;
  public country: string | undefined;
  public site: string | undefined;
  public name: string | undefined;
  public typeRef: ProjectTypeRef | undefined;
  public startDate: string | undefined;
  public activityStartDate: string | undefined;
  public gasStationCode: string | undefined;
  public scenarios: ScenarioMeta[] | undefined;
  public hasEnergyEfficiency: boolean | undefined; // NOT FED
  public sharedBy: string | undefined;
  public sharedAt: Date | undefined;
  public report: any;
  public injectionModelRef: InjectionModelRef | undefined;

  constructor(options?: any) {
    if (options) {
      this.uuid = options.uuid;
      this.name = options.name;
      this.country = options.country;
      this.hasEnergyEfficiency = options.hasEnergyEfficiency;
      this.scenarios = options.scenarios;
      this.country3Ref = options.country3Ref;
      this.site = options.site;
      this.typeRef = options.typeRef;
      this.startDate = options.startDate;
      this.activityStartDate = options.activityStartDate;
      this.gasStationCode = options.gasStationCode;
      this.sharedAt = options.sharedAt;
      this.sharedBy = options.sharedBy;
      this.injectionModelRef = options.injectionModelRef;
    }
  }
}
